<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/Ilustracion.gif" alt="login" class="mx-auto" style="max-width:100%">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 py-12">

                <div class="vx-card__title mb-12">
                  <img src="@/assets/images/logo/logo.png" alt="login" class="mx-auto my-6" style="max-width:100%">
                  <img src="@/assets/images/logo/logo_meli.png" alt="login" class="mx-auto my-6" style="max-width:100%">
                </div>


                <div class="mt-6 mb-2 text-center">
                  <div v-if="errorMessage">
                    <div class="text-error">{{errorMessage}}</div>
                  </div>
                  <div v-else>
                     <div>Autenticando....</div> 
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {

    data(){
      return {
        passedData: {},
        errorMessage: null
      }
    },
    
    async mounted() {
        // console.log('StartCDSLogin Mounted');
        // console.log(this.$route.query);
        this.passedData = this.$route.query;
        await this.getSanctumCSRFToken(); 
        let loginResp = await this.doLogin();
        // console.log(loginResp.data);
        if(loginResp.data.valid) {
          window.location.href = loginResp.data.redirect_to_url
        } else {
          this.errorMessage = loginResp.data.message
        }
    },

    methods: {

        async getSanctumCSRFToken(){
            // console.log('getSanctumCSRFToken()');
            let cookieResp = await axios.get( process.env.VUE_APP_BACKEND_URL + 'sanctum/csrf-cookie');
            // console.log(cookieResp)

        },

        async doLogin(){
            // console.log('doLogin()');
            let loginResp = await axios.post( process.env.VUE_APP_BACKEND_URL + 'api/do-login', this.passedData);
            // console.log(loginResp);
            return loginResp;
            
        }

    }
    
}
</script>